import { useEffect, useRef } from 'react'

/**
 * Caches a value using `useRef` and returns it.
 * The value will persist across renders.
 */
export function useCached<T>(value: T): T | undefined {
  const ref = useRef<T>(undefined)

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}
